/* STPK: comportamentos do redesign */

// Página do produto (computador): a coluna da direita fica fixa no MEIO da tela ao rolar.
// Calcula o "top" do sticky = (altura da janela - altura da coluna) / 2, nunca abaixo do cabeçalho.
(function () {
  function ajustar() {
    var col = document.querySelector('.product-information__grid .group-block:has(> .group-block-content > .buy-buttons-block)');
    if (!col) return;
    var header = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 60;
    var topo = Math.max(header + 16, (window.innerHeight - col.offsetHeight) / 2);
    col.style.setProperty('--stpk-topo-direita', Math.round(topo) + 'px');
  }
  window.addEventListener('load', ajustar);
  window.addEventListener('resize', ajustar);
  document.addEventListener('DOMContentLoaded', ajustar);
  if ('ResizeObserver' in window) {
    document.addEventListener('DOMContentLoaded', function () {
      var col = document.querySelector('.product-information__grid .group-block:has(> .group-block-content > .buy-buttons-block)');
      if (col) new ResizeObserver(ajustar).observe(col);
    });
  }
})();
